import React from "react";
import { useHistory } from "react-router";

import {
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
} from "@teamrota/rota-design";

import { EmptyText, IconDiv } from "~/src/components/payroll/style";
import IconLink from "~/src/containers/payroll/components/IconLink";
import Icon from "~/src/components/icon";
import { formatDateMonthTimeShort } from "~/src/utils/formatting";

import { ScrollableTable } from "../styles";
import { COL_WIDTHS } from ".";

interface TableProps {
  warnings: any[];
  loading: boolean;
}

const Table: React.FC<TableProps> = ({ warnings, loading }) => {
  const history = useHistory();

  const handleClickStream = (streamId: number) => {
    history.push(`/shiftstream/streams/${streamId}`);
  };

  return (
    <ScrollableTable colWidths={COL_WIDTHS}>
      <THead>
        <TrHead>
          <Th>ID</Th>
          <Th>Date/Time</Th>
          <Th>Message</Th>
          <Th>Stream</Th>
          <Th>Shift</Th>
          <Th>Member</Th>
          <Th>Other</Th>
          <Th>&nbsp;</Th>
        </TrHead>
      </THead>

      <TBody className="streams-table-scroll-body">
        {!loading && warnings?.length ? (
          warnings.map((warning: any) => {
            return (
              <Tr key={warning.id}>
                <Td>
                  <InnerCell>
                    <span style={{ width: "4vw" }}>#{warning.id}</span>
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {formatDateMonthTimeShort(warning?.lastSeenAt)}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>{warning.message}</InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {warning.streamId && (
                      <a
                        href="#"
                        onClick={() => handleClickStream(warning.streamId)}
                      >
                        #{warning.streamId}
                      </a>
                    )}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell style={{ fontSize: "80%" }}>
                    {warning?.shift && (
                      <>
                        {warning.shift.sourceAccount.accountName}
                        <br />
                        {warning.shift.venue.name}
                        <br />
                        {warning.shift.role.name} @{" "}
                        {formatDateMonthTimeShort(warning.shift.startTime)}
                      </>
                    )}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {warning?.member?.firstName} {warning?.member?.lastName}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {warning.extra && (
                      <div style={{ fontSize: "80%" }}>
                        {Object.entries(warning.extra).map(
                          ([key, value]: [string, any]) => (
                            <div key={key}>
                              {key}: {String(value)}
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </InnerCell>
                </Td>

                <Td>
                  {warning.screenshot && (
                    <IconDiv>
                      <IconLink
                        name="VISIBLE"
                        size={30}
                        isButton
                        color={Icon.colors.MAIN_ORANGE}
                        tooltip="View Screenshot"
                        onClick={() => {}}
                      />
                    </IconDiv>
                  )}

                  <IconDiv>
                    <IconLink
                      name="CLOSE"
                      size={20}
                      isButton
                      color={Icon.colors.MAIN_ORANGE}
                      tooltip="Archive"
                      onClick={() => {}}
                    />
                  </IconDiv>
                </Td>
              </Tr>
            );
          })
        ) : (
          <Tr>
            <Td colSpan={7}>
              <EmptyText>
                {!loading && "None found 👀"}
                {loading && "Loading... ⏳"}
              </EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </ScrollableTable>
  );
};

export default Table;
